/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Bottom_RightInputs */

const en_mobile_scan_bottom_right = /** @type {(inputs: Mobile_Scan_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom right corner`)
};

const es_mobile_scan_bottom_right = /** @type {(inputs: Mobile_Scan_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquina inferior derecha`)
};

/**
* | output |
* | --- |
* | "Bottom right corner" |
*
* @param {Mobile_Scan_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_bottom_right = /** @type {((inputs?: Mobile_Scan_Bottom_RightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Bottom_RightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_bottom_right(inputs)
	return en_mobile_scan_bottom_right(inputs)
});